// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"information_wrapper_1m9SUbz","primary":"information_primary_1ny56ak"};